import Shelter4uSVgIcon from "Components/CommonComponent/Shelter4uSVgIcon/Shelter4uSVgIcon";
import { memo } from "react";
import { Container } from "reactstrap";

const BrandPageLoader = memo(({ className = "", cmpName = "PropsForce" }) => {
  return (
    <div className="page-content">
      <Container fluid>
        <div
          className={`${className} d-flex flex-column justify-content-center align-items-center w-100 h-100`}
          style={{ minHeight: "60vh" }} // Safety height agar content area chota ho
        >
          {/* Logo Container with Float Animation */}
          <div className="logo-container">
            <Shelter4uSVgIcon width="120" height="130" />
          </div>

          {/* Animated Brand Text */}
          <div className="text-center mt-3">
            <h1 className="brand-text m-0">{cmpName}</h1>
            {/* Optional Subtext for better UX */}
            <p className="loading-subtext mt-1">Please wait...</p>
          </div>

          <style>{`
        /* 1. Floating Animation (Smooth) */
        .logo-container {
          animation: floatLogo 3s ease-in-out infinite;
          filter: drop-shadow(0px 10px 15px rgba(0,0,0,0.1)); /* Logo ke niche halki shadow */
        }

        /* 2. Text Shimmer Animation */
        .brand-text {
          font-size: 26px; /* Thoda bada kiya */
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 3px;
          
          /* Premium Gradient */
          background: linear-gradient(
            to right,
            #2c3e50 20%,
            #e74c3c 40%, /* Red hint (brand color) beech me */
            #2c3e50 60%
          );
          background-size: 200% auto;
          
          color: #000;
          background-clip: text;
          text-fill-color: transparent;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          
          animation: shineText 2.5s linear infinite;
        }

        /* 3. Subtext Styling */
        .loading-subtext {
          font-size: 14px;
          color: #95a5a6;
          font-weight: 500;
          letter-spacing: 1px;
          animation: pulseText 1.5s infinite;
        }

        /* Keyframes */
        @keyframes floatLogo {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }

        @keyframes shineText {
          to { background-position: 200% center; }
        }

        @keyframes pulseText {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
      `}</style>
        </div>
      </Container>
    </div>
  );
});

export default BrandPageLoader;
